/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';

// Los textos van hardcodeados en español a propósito: la familia nunca se tradujo.
// Los bloques de movimiento no tienen campo `units` (en prod tampoco): el
// generador lo lee igual y obtiene null, como prod. Ver la nota en el generador.

// takeoff no tiene previousStatement y land no tiene nextStatement: son el
// principio y el fin de la misión, y el perfil pone takeoff fijo en el canvas.
Blockly.Blocks.takeoff = {
  init: function () {
    this.jsonInit({
      message0: 'Despegar',
      nextStatement: true,
      colour: colors.COLOUR_CONTROL,
    });
  },
};

Blockly.Blocks.land = {
  init: function () {
    this.jsonInit({
      message0: 'Aterrizar',
      previousStatement: true,
      colour: colors.COLOUR_CONTROL,
    });
  },
};

const movimiento = (message0) => ({
  init: function () {
    this.jsonInit({
      message0,
      args0: [{ type: 'input_value', name: 'distance' }],
      previousStatement: true,
      nextStatement: true,
      colour: colors.COLOUR_ENTRADAS,
    });
  },
});

Blockly.Blocks.set_speed = {
  init: function () {
    this.jsonInit({
      message0: 'establecer velocidad en %1 cm por segundo',
      args0: [{ type: 'input_value', name: 'speed' }],
      previousStatement: true,
      nextStatement: true,
      colour: colors.COLOUR_ENTRADAS,
    });
  },
};

Blockly.Blocks.fly_forward = movimiento('volar hacia adelante %1 cm');
Blockly.Blocks.fly_backward = movimiento('volar hacia atrás %1 cm');
Blockly.Blocks.fly_left = movimiento('volar hacia la izquierda %1 cm');
Blockly.Blocks.fly_right = movimiento('volar hacia la derecha %1 cm');
Blockly.Blocks.fly_up = movimiento('volar hacia arriba %1 cm');
Blockly.Blocks.fly_down = movimiento('volar hacia abajo %1 cm');

Blockly.Blocks.fly_xyz = {
  init: function () {
    this.jsonInit({
      message0: 'volar hacia x %1 y %2 z %3 cm, con velocidad %4 cm por segundo',
      args0: [
        { type: 'input_value', name: 'xdistance' },
        { type: 'input_value', name: 'ydistance' },
        { type: 'input_value', name: 'zdistance' },
        { type: 'input_value', name: 'speed' },
      ],
      previousStatement: true,
      nextStatement: true,
      colour: colors.COLOUR_ENTRADAS,
    });
  },
};

Blockly.Blocks.curve = {
  init: function () {
    this.jsonInit({
      message0: 'curva por x1 %1 y1 %2 z1 %3 x2 %4 y2 %5 z2 %6 cm, con velocidad %7 cm por segundo',
      args0: [
        { type: 'input_value', name: 'x1distance' },
        { type: 'input_value', name: 'y1distance' },
        { type: 'input_value', name: 'z1distance' },
        { type: 'input_value', name: 'x2distance' },
        { type: 'input_value', name: 'y2distance' },
        { type: 'input_value', name: 'z2distance' },
        { type: 'input_value', name: 'speed' },
      ],
      previousStatement: true,
      nextStatement: true,
      colour: colors.COLOUR_ENTRADAS,
    });
  },
};

const giro = (message0) => ({
  init: function () {
    this.jsonInit({
      message0,
      args0: [{ type: 'input_value', name: 'angle' }],
      previousStatement: true,
      nextStatement: true,
      colour: colors.COLOUR_ENTRADAS,
    });
  },
});

Blockly.Blocks.yaw_left = giro('girar a la izquierda %1 grados');
Blockly.Blocks.yaw_right = giro('girar a la derecha %1 grados');

const pirueta = (message0) => ({
  init: function () {
    this.jsonInit({
      message0,
      previousStatement: true,
      nextStatement: true,
      colour: colors.COLOUR_LCD,
    });
  },
});

Blockly.Blocks.flip_forward = pirueta('voltear hacia adelante');
Blockly.Blocks.flip_backward = pirueta('voltear hacia atrás');
Blockly.Blocks.flip_left = pirueta('voltear hacia la izquierda');
Blockly.Blocks.flip_right = pirueta('voltear hacia la derecha');
